import styled from 'styled-components';
import xor from 'lodash/xor';
import { ButtonSize, GhostButton } from '@ardoq/button';
import { ICON_SELECTOR, Icon, IconName } from '@ardoq/icons';
import { colors } from '@ardoq/design-tokens';
import { type I18nLocale, t } from '@ardoq/i18n';

export const ExpandRowButtonComponent = styled(GhostButton)`
  ${({ isActive }) =>
    isActive &&
    `background-color: ${colors.transparent10};
     color: ${colors.grey900};
     ${ICON_SELECTOR} {
        color: ${colors.grey900};
      }
      &:active {
          background-color: ${colors.transparent10};
          color: ${colors.grey900};
        }
      &:hover {
        background-color: ${colors.transparent10};
      }
    `};
`;

type ExpandRowButtonProps = {
  expandedRowIds: string[];
  setExpandedRowIds: (expandedRowIds: string[]) => void;
  rowId: string;
  i18nLocale: I18nLocale;
};

export const ExpandRowButton = ({
  expandedRowIds,
  setExpandedRowIds,
  rowId,
  i18nLocale,
}: ExpandRowButtonProps) => (
  <ExpandRowButtonComponent
    buttonSize={ButtonSize.REGULAR}
    isActive={expandedRowIds.includes(rowId)}
    onClick={() => setExpandedRowIds(xor(expandedRowIds, [rowId]))}
  >
    {t(i18nLocale, 'integrations:expandRowButton.viewDetails', 'View details')}{' '}
    <Icon
      iconName={
        expandedRowIds.includes(rowId)
          ? IconName.CHEVRON_UP
          : IconName.CHEVRON_DOWN
      }
    />
  </ExpandRowButtonComponent>
);
